import React from 'react';

export default function IFrame({ data, id }) {
  return (
    <div className={data.className} id={id}>
      <iframe
        title="Iframe"
        src={data.pageUrl}
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
      />
    </div>
  );
}